
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipeSearch",
      function () {
        return require("private-next-pages/recipeSearch/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipeSearch"])
      });
    }
  